import { APICore } from "./apiCore";

const api = new APICore();

// Get all locations
function getLocations(status?: string, page?: number, limit?: number) {
  const baseUrl = "/web/locations";
  const params: any = {};
  if (status) params.status = status;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  return api.get(`${baseUrl}`, params);
}

// Update a location
function updateLocationApi(params: {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  address: string;
  phone: string;
  starting_hour: string;
  ending_hour: string;
  is_active: boolean;
  code: any;
}) {
  const baseUrl = "/web/locations";
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

// Add a new location
function addLocationApi(params: {
  name: string;
  latitude: number;
  longitude: number;
  address: string;
  phone: string;
  starting_hour: string;
  ending_hour: string;
  is_active: boolean;
  code: any;
}) {
  const baseUrl = "/web/locations";
  return api.create(`${baseUrl}`, params);
}

function deleteLocationApi(params: { id: string }) {
  const baseUrl = "/web/locations";
  return api.delete(`${baseUrl}/${params.id}`);
}

export { getLocations, updateLocationApi, addLocationApi, deleteLocationApi };
